import { ChevronLeft, ChevronRight, PlaylistPlay } from '@mui/icons-material';
import { Button, IconButton, Typography, styled, useTheme } from '@mui/material';
import { type ReactNode } from 'react';
import { NavContainer, TitleContainer } from '#components/Modal/VideoModal.tsx';

const Container = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  alignItems: 'center',
  display: 'flex',
  marginTop: theme.spacing(2),
}));

export type PlayerHeaderProps = {
  children: ReactNode;
  hasNext?: boolean;
  hasPrev?: boolean;
  onNext?: () => void;
  onOpenPlaylist?: () => void;
  onPrev?: () => void;
  playlist?: boolean;
};

export const PlayerNavigation = ({
  children,
  hasNext,
  hasPrev,
  onNext,
  onOpenPlaylist,
  onPrev,
  playlist = false,
}: PlayerHeaderProps) => {
  const theme = useTheme();

  return (
    <Container>
      <TitleContainer
        sx={{
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
          flexGrow: 1,
          paddingRight: theme.spacing(2),
          width: 'calc(100% - 150px)',
        }}
      >
        {playlist ? (
          <IconButton
            aria-label="Open playlist"
            onClick={onOpenPlaylist}
            sx={{
              color: theme.palette.grey[200],
              marginRight: theme.spacing(1.5),
            }}
          >
            <PlaylistPlay />
          </IconButton>
        ) : undefined}
        <Typography
          sx={{
            color: theme.palette.grey[200],
            flexGrow: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {children}
        </Typography>
      </TitleContainer>
      {playlist ? (
        <NavContainer
          sx={{
            [theme.breakpoints.down('sm')]: {
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            },
            flexShrink: 0,
          }}
        >
          <Button disabled={!hasPrev} onClick={onPrev} startIcon={<ChevronLeft />} variant="text">
            Prev
          </Button>
          <Button disabled={!hasNext} endIcon={<ChevronRight />} onClick={onNext} variant="text">
            Next
          </Button>
        </NavContainer>
      ) : undefined}
    </Container>
  );
};
